import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSessionMasters } from "../../store/slices/sessionSlice";
import { fetchSessionCategories } from "../../store/slices/sessionCategorySlice";
import Select from "react-select";

const SubSessionTypeForm = ({ formData, handleChange }) => {
    const dispatch = useDispatch();
    const { sessionMasters } = useSelector((state) => state.sessions);
    const { sessionCategories } = useSelector((state) => state.sessionCategories);

    useEffect(() => {
        dispatch(fetchSessionMasters());
        dispatch(fetchSessionCategories());
    }, [dispatch]);

    // Filter active categories and session types
    const activeCategories = (sessionCategories || []).filter(c => c.status === "active");
    const activeSessions = (sessionMasters || []).filter(s => s.status === "active");

    const categoryOptions = activeCategories.map(c => ({
        value: c.id,
        label: c.name
    }));

    // Premium logic: filter session type options by selected category
    const filteredSessions = formData.sessionCategoryMasterId
        ? activeSessions.filter(s => s.session_category_master_id === parseInt(formData.sessionCategoryMasterId))
        : activeSessions;

    const sessionOptions = filteredSessions.map(s => ({
        value: s.id,
        label: s.name
    }));

    const departmentOptions = [
        { value: "PRP", label: "PRP" },
        { value: "Nursing", label: "Nursing" }
    ];

    const statusOptions = [
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" }
    ];

    const selectStyles = {
        control: (base) => ({
            ...base,
            minHeight: '38px',
            fontSize: '0.875rem',
            borderRadius: '0.375rem',
            borderColor: '#d9dee3',
            '&:hover': { borderColor: '#d9dee3' }
        }),
        menu: (base) => ({ ...base, fontSize: '0.875rem', zIndex: 9999 }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#666ee8' : state.isFocused ? '#f5f5f9' : 'white',
            color: state.isSelected ? 'white' : '#566a7f',
            cursor: 'pointer',
        })
    };

    const currentCategory = categoryOptions.find(opt => opt.value === parseInt(formData.sessionCategoryMasterId)) || null;
    const currentSession = sessionOptions.find(opt => opt.value === parseInt(formData.sessionMasterId)) || null;
    const currentDepartment = departmentOptions.find(opt => opt.value === formData.department) || null;
    const currentStatus = statusOptions.find(opt => opt.value === formData.status) || statusOptions[0];

    return (
        <div className="content p-4">
            <div className="row g-3">
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-2 py-1 mb-3">
                        Sub Session Type Information
                    </small>
                </div>

                <div className="col-md-4">
                    <div className="mb-3">
                        <label className="form-label small fw-bold">Session Category <span className="text-danger">*</span></label>
                        <Select
                            options={categoryOptions}
                            styles={selectStyles}
                            value={currentCategory}
                            onChange={(opt) => {
                                handleChange({ target: { name: "sessionCategoryMasterId", value: opt ? opt.value : "" } });
                                // Reset sessionMasterId if category changes
                                handleChange({ target: { name: "sessionMasterId", value: "" } });
                            }}
                            placeholder="Select Session Category"
                            isSearchable
                        />
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="mb-3">
                        <label className="form-label small fw-bold">Session Type <span className="text-danger">*</span></label>
                        <Select
                            options={sessionOptions}
                            styles={selectStyles}
                            value={currentSession}
                            onChange={(opt) => handleChange({ target: { name: "sessionMasterId", value: opt ? opt.value : "" } })}
                            placeholder={formData.sessionCategoryMasterId ? "Select Session Type" : "Please select Category first"}
                            isSearchable
                            isDisabled={!formData.sessionCategoryMasterId}
                        />
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="mb-3">
                        <label className="form-label small fw-bold">Department <span className="text-danger">*</span></label>
                        <Select
                            options={departmentOptions}
                            styles={selectStyles}
                            value={currentDepartment}
                            onChange={(opt) => handleChange({ target: { name: "department", value: opt ? opt.value : "" } })}
                            placeholder="Select Department"
                            isSearchable={false}
                        />
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="form-floating form-floating-outline mb-3" style={{ marginTop: '22px' }}>
                        <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={formData.name || ""}
                            onChange={handleChange}
                            placeholder="Enter Name"
                            required
                        />
                        <label>Name <span className="text-danger">*</span></label>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="mb-3">
                        <label className="form-label small fw-bold">Status</label>
                        <Select
                            options={statusOptions}
                            styles={selectStyles}
                            value={currentStatus}
                            onChange={(opt) => handleChange({ target: { name: "status", value: opt ? opt.value : "active" } })}
                            placeholder="Select Status"
                            isSearchable={false}
                        />
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="form-floating form-floating-outline mb-3">
                        <textarea
                            className="form-control"
                            name="description"
                            value={formData.description || ""}
                            onChange={handleChange}
                            placeholder="Enter Description"
                            style={{ height: "100px" }}
                        />
                        <label>Description</label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubSessionTypeForm;

